export default __webpack_public_path__ + "locales/hy-AM/EmptyView.json?hash=50f3749e65b54b41e8505f507820acd7";